import { render, staticRenderFns } from "./SelectOrderItemComments.vue?vue&type=template&id=c5bf5408&scoped=true&"
import script from "./SelectOrderItemComments.vue?vue&type=script&lang=js&"
export * from "./SelectOrderItemComments.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrderItemComments.vue?vue&type=style&index=0&id=c5bf5408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bf5408",
  null
  
)

export default component.exports